import { Box, Grid, Link, Paper, Typography } from '@mui/material';

import type { FunctionComponent } from 'react';
import { MdHourglassEmpty } from 'react-icons/md';
import { SystemConstants } from '../../modules/prelude/constants';
import WaitViaSMS from './WaitViaSMS';
import type { ISMSOptInProcessActive } from '../../modules/algebra/waiting-room';

interface WaitingContainerProps {
  queuePosition: number;
  wait_via_sms_enabled?: boolean;
  messaging_service_key?: string;
  task_sid?: string;
  waiting_via_sms?: boolean;
  webchat_language: string;
  wait_via_sms_data?:ISMSOptInProcessActive;
  isSMSOptInProcessActive?:boolean
}

const WaitingContainer: FunctionComponent<WaitingContainerProps> = ({ queuePosition, wait_via_sms_enabled, messaging_service_key, task_sid, waiting_via_sms = false, webchat_language = 'en',wait_via_sms_data ,isSMSOptInProcessActive}) => {
  return (
    <Grid container className="justify-center" spacing={4}>
      <Grid item sm={wait_via_sms_enabled && queuePosition >= 2 ? 5 : waiting_via_sms ? 5 : 10}>
        <Box className=" border-1 p-3 h-full">
          <div className="grid grid-cols-12">
            <div className="col-span-12 sm:col-span-8">
              <Typography variant="h1" className="text-base font-bold">
                <MdHourglassEmpty className="ml-5px inline text-xl" />
                {queuePosition === SystemConstants.INITIAL_POSITION ? (
                  <>{webchat_language == 'en' ? 'You are Next In Line' : 'Usted es la próxima persona en fila'}</>
                ) : queuePosition === 1 ? (
                  <> {webchat_language == 'en' ? 'There is 1 visitor ahead of you.' : 'Hay 1 visitante delante de ti.'}</>
                ) : (
                  <> {webchat_language == 'en' ? `There are ${queuePosition} visitors ahead of you.` : `Hay ${queuePosition} visitantes delante de ti.`}</>
                )}
              </Typography>
            </div>
          </div>
          <Typography variant="body1" className="text-base py-2">
            {webchat_language == 'en'
              ? 'When a support specialist becomes available, your chat will begin on this page.'
              : 'Cuando un especialista de soporte esté disponible, su chat comenzará en esta página.'}
          </Typography>
          <Typography variant="body1" className="text-base">
            {webchat_language == 'en'
              ? 'Please keep this window open. If you navigate away, close, or refresh this window, you may lose your place in line.'
              : 'Por favor, mantenga esta ventana abierta. Si navega fuera, cierra o actualiza esta ventana, puede perder su lugar en la fila.'}
            <span className="font-bold">
              {webchat_language == 'en'
                ? 'If you are in danger, need emergency assistance or are considering suicide please call 911 (United States) or your local authorities immediately.'
                : 'Si enfrenta un peligro inminente, llame al 911.'}
            </span>
          </Typography>
        </Box>
      </Grid>
      {wait_via_sms_enabled && (queuePosition >= 2 || waiting_via_sms) && (
        <Grid item sm={5}>
          <WaitViaSMS wait_via_sms_data={wait_via_sms_data} isSMSOptInProcessActive={isSMSOptInProcessActive} messaging_service_key={messaging_service_key} task_sid={task_sid} />
        </Grid>
      )}
      {webchat_language == 'en' && (
        <Grid item sm={2}>
          <Paper elevation={0} className="border-1 h-full flex items-center justify-center">
            <Typography variant="body1" className="text-base p-4 text-center md:py-0">
              If you are in the military, you can visit <br />
              <Link target="_blank" href="https://chat-ohl4.safehelpline.org/tos/SHL">
                Safe Helpline for support
              </Link>
            </Typography>
          </Paper>
        </Grid>
      )}
    </Grid>
  );
};

export default WaitingContainer;
